import { useEffect, useState } from "react";
import { Download, Plane } from "lucide-react";
import { api } from "../lib/api";

// Employee portal: «تذاكري» — flight tickets uploaded by the company
export const PortalFlights = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.portalFlights().then((d) => setItems(d.items || [])).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <div className="space-y-2 rounded-2xl border border-sky-200 bg-sky-50/50 p-4" data-testid="portal-flights">
      <h3 className="flex items-center gap-2 font-heading font-bold text-sky-900"><Plane className="h-5 w-5" /> تذاكري</h3>
      {items.map((b) => (
        <div key={b.id} className="flex flex-wrap items-center gap-3 rounded-xl bg-white p-3 shadow-sm" data-testid={`portal-flight-${b.id}`}>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-bold text-slate-800">{b.from_city || "—"} ← {b.to_city || "—"} <span className="text-xs font-normal text-slate-400">#{b.number}</span></p>
            <p className="text-xs text-slate-500">الذهاب {b.depart_date}{b.return_date ? ` · العودة ${b.return_date}` : ""}{b.airline ? ` · ${b.airline}` : ""} · {b.travelers?.length || 1} مسافر</p>
          </div>
          <a href={`${api.portalFileUrl(b.ticket_id)}?download=1`} className="inline-flex items-center gap-1.5 rounded-lg bg-sky-600 px-3 py-2 text-xs font-bold text-white hover:bg-sky-700" data-testid={`portal-flight-ticket-${b.id}`}>
            <Download className="h-4 w-4" /> تنزيل التذكرة</a>
        </div>))}
    </div>
  );
};
